import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionnairesFilesComponent } from '../../../share-componnents/questionnaires-files/questionnaires-files.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { QuestionnairesListComponent } from './components/questionnaires-list/questionnaires-list.component';
import { Router, RouterOutlet } from '@angular/router';
import { ManipulationsToolbarComponent } from "../../../../../../shared/components/manipulations-toolbar/manipulations-toolbar.component";
import { toSignal } from '@angular/core/rxjs-interop';
import { GlobalStore } from 'src/app/store/global-store';
import { LoggedUserComponent } from 'src/app/shared/components/logged-user/logged-user.component';
import { environment } from 'src/environment';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs';



@Component({
    selector: 'que-questionnaires-list-page',
    templateUrl: './questionnaires-list-page.component.html',
    styleUrls: ['./questionnaires-list-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet, CommonModule, QuestionnairesListComponent, LoggedUserComponent, QuestionnairesFilesComponent, TranslateDirective, TranslatePipe, ManipulationsToolbarComponent]
})
export class QuestionnairesListPageComponent {
  #router = inject(Router);
  #globalStore = inject(GlobalStore);
  #breakpointObserver = inject(BreakpointObserver);

  isAmdocs$ = toSignal(this.#globalStore.isAmdocs$);
  client = environment.client;
  isRoleAdmin$ = toSignal(this.#globalStore.isRoleAdmin$);
  userDetails$ = toSignal(this.#globalStore.loggedUserDetails$);
  isAdmin$ = toSignal(this.#globalStore.isRoleAdmin$);
  isNavbarOpen = true;
  title = environment.title;
  constructor() {

    this.#breakpointObserver.observe('(max-width: 1399px)')
      .pipe(
        map(result => result.matches)
      )
      .subscribe(isMatch => {
        if (isMatch) {
          this.isNavbarOpen = false;
        }
      });

  }



  closeNavMobile() {
    this.isNavbarOpen = false;
  }
  // ChangeRole() {
  //   this.#userStore.changeRoleStammmm();
  // }
  goToBoardirector() {
    window.location.href = this.isRoleAdmin$() ? environment.boardirectorUrl : environment.directorsViewUrl;
    // window.open(environment.boardirectorUrl, '_blank');
  }
}
